import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAlert,
  setLoading,
  updateFloatPanel,
  updateFloatPanelData,
} from "../../reducers/userConfigSlice";
import { IoMdClose } from "react-icons/io";
//import { SwitchText } from "@delibrandev/utils";
import { HorizontalNavigation } from "../../components/horizontalNavigation";
import "./style.css";

/**
 * Componente genérico que gestiona el contenido de un panel flotante editable.
 * Se encarga de:
 * - Mostrar encabezado con botón de cierre e interruptor "Activo"
 * - Cargar datos al cambiar el `queryId`
 * - Mostrar navegación horizontal y pestañas con contenido dinámico
 */
export const PanelContent = ({
  getQuery,
  /*handleActive = null,*/ horizontalNavigation = [],
  tabsContent,
  entityLabel = "registro",
}) => {
  console.log(" == PanelContent ==");
  const dispatch = useDispatch();
  const queryId = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.queryId,
  );
  const isEmpty = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.isEmpty,
  );
  const data = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.data,
  );
  const [tabActive, setTabActive] = useState(0);

  /**
   * Cierra el panel flotante y reinicia su estado en Redux.
   */
  const closeFloatPanel = () => {
    dispatch(
      updateFloatPanel({ visible: false, queryId: null, isEmpty: true }),
    );
  };

  /**
   * Llama a la función `getQuery` pasada por props para obtener datos según `queryId`.
   * Actualiza el estado global del panel con la respuesta del servidor.
   */
  const get = async () => {
    dispatch(setLoading(true));
    try {
      const response = await getQuery(queryId);
      if (response && !response.error) {
        dispatch(updateFloatPanelData({ data: response.data }));
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
    dispatch(setLoading(false));
  };

  /**
   * Controla el cambio de pestañas en la navegación horizontal.
   * Evita pasar a pestañas bloqueadas si el panel aún está vacío.
   */
  const handleHorizontalNavigation = (idTab) => {
    if ((idTab > 0 && !isEmpty) || idTab === 0 || queryId !== null)
      setTabActive(idTab);
    if (idTab > 0 && isEmpty)
      dispatch(
        setAlert({
          called: true,
          title: "Error",
          message: "Antes debes guardar los cambios",
          type: "error",
        }),
      );
  };

  /**
   * Cada vez que cambia `queryId`:
   * - Llama a `get()` para obtener datos si el panel no está vacío.
   * - Desactiva el scroll vertical del cuerpo principal mientras el panel está abierto.
   * - Restaura el scroll al desmontar o cambiar de `queryId`.
   */
  useEffect(() => {
    !isEmpty && get();
    const adminBody = document.getElementById("adminBody");
    if (queryId && adminBody) adminBody.style.overflowY = "hidden";
    return () => {
      if (adminBody) adminBody.style.overflowY = "auto";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryId]);

  return (
    <>
      <div className="editorStickyTop">
        <div className="floatPanelHeader">
          <div className="floatPanelHeaderLeft">
            <button
              type="button"
              onClick={() => closeFloatPanel(false)}
              className="floatPanelCloseButton"
              aria-label="Cerrar panel"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  closeFloatPanel(false);
                }
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <IoMdClose />
            </button>

            <div className="editorHeading">
              <span className="editorEyebrow">
                {isEmpty ? "Nuevo registro" : "Edición"}
              </span>
              <h2 id="admin-editor-title">
                {!isEmpty
                  ? data?.name ||
                    data?.fullname ||
                    data?.itemGroup?.name ||
                    `Editar ${entityLabel}`
                  : `Crear ${entityLabel}`}
              </h2>
            </div>

            {/*!isEmpty && handleActive !== null && (
            <div className="isActive">
              Activo
              <SwitchText
                defaultChecked={data.status === "PUBLISHED" ? true : false}
                onChange={() => handleActive(data.status === "PUBLISHED" ? "DRAFT" : "PUBLISHED")}
              />
            </div>
          )*/}
          </div>
          <div className="floatPanelHeaderRight"></div>
        </div>

        {/* Navegación horizontal dinámica de pestañas */}
        {horizontalNavigation.length > 0 && (
          <HorizontalNavigation
            options={horizontalNavigation}
            callback={handleHorizontalNavigation}
            tabActive={tabActive}
          />
        )}
      </div>
      {isEmpty && entityLabel === "producto" && (
        <p className="editorStepHint">
          Guarda el producto para continuar con alérgenos, extras y variantes.
        </p>
      )}
      <div className="floatPanelBody">
        {tabsContent[tabActive] ? tabsContent[tabActive].content : <></>}
      </div>
    </>
  );
};
